import _ from "lodash";
import { EMPTY_CELL } from "../constants";

const getTextCellProps = ({ node, cellConfig, customConfig }) => {
  const { styles } = cellConfig || {};
  const {
    property,
    showEmptyCellAsFallback = false,
    labelMap,
    isValueInArray = false,
    valueIdentifier,
    getValue,
  } = customConfig || {};

  let value = _.get(node, property) || "";

  if (isValueInArray) {
    const foundValue = _.find(value, valueIdentifier);
    value = getValue(foundValue);
  }

  if (!value && showEmptyCellAsFallback) return { ...EMPTY_CELL, styles };

  return {
    ...cellConfig,
    value: labelMap ? labelMap[value] : value,
  };
};

export default getTextCellProps;
